export default __webpack_public_path__ + "static/media/pwrsCardBanner.3e7cf85b.svg";